<template>
  <div class="upload-file">
    <div v-if="!isVideoSelected">
      <button class="upload-file-button" @click="openUppy">
        <img src="@/assets/images/upload_white_arrow.svg" class="upload-file-icon"/>
        <span class="upload-file-text">
            <span class="big-text"> {{ $t('SELECT_FILE') }} </span>
            <span>
              <span class="text">
                {{ $t('UPLOAD_OPTIONS') }}
              </span>
              <span
                class="text"
                v-for="(option, index) in allowedFileTypes"
                :key="index"
              >
                {{ option.substring(1) + ',' }}
              </span>
              <span class="text">
                {{ $t('UP_TO') }} {{ maxUploadSize / 100000000 + 'GB' }}
              </span>
            </span>
          </span>
      </button>
      <p v-if="uploadSuccess === false" class="error-text">
        {{ $t('FILE_UPLOAD_FAILED') }}
      </p>
    </div>
    <div v-else class="video">
      <div class="card">
        <iframe v-if="showVideo"
          :src="selectedVideo.uploadURL"
          frameborder="0"
          height="120"
          width="200">
        </iframe>
        <div v-else class="uploaded-file-container">
          <img src="@/assets/images/video_file_upload.svg" class="file-icon rotate-icon" />
          <p class="file-name">
            {{ selectedVideo.name }}
          </p>
        </div>
        <button class="change-file" @click="openUppy">
          <img src="@/assets/images/return_arrow_icon.svg" class="return-icon"/>
          <span>{{ $t('CHANGE_VIDEO') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import { uploadConfig } from '@/constants'

export default {
  name: 'video-upload-header',

  data () {
    return {
      isVideoSelected: false,
      allowedFileTypes: [
        '.mov',
        '.mp4'
      ],
      maxUploadSize: uploadConfig.maxVimeoUploadSize,
      showVideo: false
    }
  },

  computed: {
    ...mapState({
      selectedEntryOrigin: state => state.collections.selectedEntryOrigin,
      selectedEntry: state => state.collections.selectedEntry,
      uploadSuccess: state => state.uploads.uploadSuccess,
      selectedVideo: state => state.uploads.uploadFile
    })
  },

  created () {
    // if we came from 'collectionEntry' then we need to display the selectedEntry data of file
    if (this.selectedEntryOrigin === 'collectionEntry') {
      this.isVideoSelected = true
      this.showVideo = true
      this.$store.dispatch('setUploadFile', { uploadURL: this.selectedEntry.object.url })
    }
  },

  watch: {
    uploadSuccess (newValue) {
      // after success upload
      if (newValue) {
        this.isVideoSelected = true
        this.showVideo = false
      }
    }
  },

  methods: {
    openUppy () {
      this.$emit('openUppy', 'video')
    }
  }
}
</script>

<style scoped>
.file-icon {
    max-width: 54px; width: 100%;
}
.file-name {
  font-size: 18px;
  line-height: 24px;
  color: #000;
  white-space: nowrap;
  margin-top: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
  direction: ltr;
}
</style>
